export default __webpack_public_path__ + "static/media/users-list-icon.38fe7c71.svg";